<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="4.2" y="2.6" width="11.6" height="14.8" rx="2"/><path d="M9 14.9h2"/></svg>
</template>
